import {UPDATE_OFFERS_ERROR, UPDATE_OFFERS_START, UPDATE_OFFERS_SUCCESS} from "../../types";

export default function update_offers(state, action) {
    switch (action.type) {
        case UPDATE_OFFERS_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case UPDATE_OFFERS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case UPDATE_OFFERS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.detail
            };
        default:
            return {...state};
    }
}
